module.exports = __webpack_public_path__ + "static/cloud-server-8c3569461bbc9341341ff73e126469a3.png";